import * as React from 'react';

export const CloseIcon = () => {
  return (
    <span className='close-icon'>
      <svg height='30' viewBox='0 0 30 30' width='30' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none' stroke='#000' strokeLinecap='round' strokeWidth='4'>
          <path d='m2 2.5 25.5 25.5' />
          <path d='m27.5 2.5-25.5 25.5' />
        </g>
      </svg>
    </span>
  );
};

export const RightArrowIcon = () => {
  return (
    <span className='right-arrow-icon'>
      <svg width='28.99' height='49.5' viewBox='0 0 28.99 49.5'>
        <path
          d='M23.85,27.92L3.34,7.41,7.58,3.17,28.09,23.67l4.24,4.24L7.58,52.66,3.34,48.42Z'
          transform='translate(-3.34 -3.17)'
        />
      </svg>
    </span>
  );
};

export const LeftArrowIcon = () => {
  return (
    <span className='left-arrow-icon'>
      <svg width='28.99' height='49.5' viewBox='0 0 28.99 49.5'>
        <path
          d='M11.83,27.92L32.33,48.42l-4.24,4.24L7.58,32.16,3.34,27.92,28.09,3.17l4.24,4.24Z'
          transform='translate(-3.34 -3.17)'
        />
      </svg>
    </span>
  );
};

// Social
export const FacebookIcon = () => {
  return (
    <span className='facebook-icon'>
      <svg width='22.7' height='48.85' viewBox='0 0 22.7 48.85'>
        <path
          d='M36.35,16.39H28.62V11.32A2.06,2.06,0,0,1,30.77,9h5.45V0.61l-7.51,0c-8.34,0-10.24,6.24-10.24,10.24v5.58H13.65V25h4.82v24.4H28.62V25h6.85Z'
          transform='translate(-13.65 -0.58)'
        />
      </svg>
    </span>
  );
};

export const TwitterIcon = () => {
  return (
    <span className='twitter-icon'>
      <svg width='47.33' height='38.46' viewBox='0 0 47.33 38.46'>
        <path
          d='M16.22,46.25c17.86,0,27.63-14.8,27.63-27.63,0-.42,0-0.84,0-1.26a19.76,19.76,0,0,0,4.85-5,19.38,19.38,0,0,1-5.58,1.53,9.74,9.74,0,0,0,4.27-5.37,19.46,19.46,0,0,1-6.17,2.36,9.72,9.72,0,0,0-16.55,8.86,27.57,27.57,0,0,1-20-10.15,9.72,9.72,0,0,0,3,13,9.64,9.64,0,0,1-4.41-1.22v0.12A9.71,9.71,0,0,0,11,31a9.7,9.7,0,0,1-4.38.17,9.72,9.72,0,0,0,9.07,6.74A19.49,19.49,0,0,1,3.65,42a19.77,19.77,0,0,1-2.31-.14,27.49,27.49,0,0,0,14.89,4.35'
          transform='translate(-1.33 -7.79)'
        />
      </svg>
    </span>
  );
};

export const PlusIcon = () => {
  return (
    <span className='plus-icon'>
      <svg width='17.98' height='17.76' viewBox='0 0 17.98 17.76'>
        <polygon points='6.93 17.76 6.93 10.87 0 10.87 0 6.86 6.93 6.86 6.93 0 11.05 0 11.05 6.86 17.98 6.86 17.98 10.87 11.05 10.87 11.05 17.76 6.93 17.76' />
      </svg>
    </span>
  );
};

export const MinusIcon = () => {
  return (
    <span className='minus-icon'>
      <svg width='18' height='4' viewBox='0 0 18 4'>
        <polygon points='0 4 0 0 18 0 18 4 0 4' />
      </svg>
    </span>
  );
};

export const EmailIcon = () => {
  return (
    <span className='email-icon'>
      <svg height='83' viewBox='0 0 83 83' width='83' xmlns='http://www.w3.org/2000/svg'>
        <g fill='#fff' transform='translate(0 .341)'>
          <path d='m10.4069189 39.4811351v-19.7638378c.0062427-2.8185404 2.2895678-5.1018655 5.1081081-5.1081081h51.2570271c2.8185403.0062426 5.1018654 2.2895677 5.1081081 5.1081081v19.7638378l9.8756756-6.7903783-6.6042162-5.4827027v-7.4918919c0-4.6329228-3.7557259-8.3886487-8.3886486-8.3886487h-10.7429189l-12.691946-10.53518918c-1.2719435-1.05560823-3.1153538-1.05560823-4.3872973 0l-12.6919459 10.53518918h-10.742919c-2.2248079 0-4.3584935.8838015-5.9316703 2.4569783-1.57317679 1.5731768-2.4569783 3.7068624-2.4569783 5.9316704v7.4918919l-6.60421622 5.4827027z' />
          <path d='m43.0942703 62.3291351c-1.1720129.80554-2.7192304.80554-3.8912433 0l-39.203027-26.9435675v41.9829729c0 2.7013889 2.18990839 4.8912973 4.8912973 4.8912973h72.5158378c2.7013889 0 4.8912973-2.1899084 4.8912973-4.8912973v-41.9829729z' />
          <path d='m52.4239459 43.9728649h3.1954055c-1.0018915 2.0298413-2.6121828 3.696481-4.6063784 4.7675675-2.6734168 1.3922267-5.6596742 2.0742972-8.6724325 1.9808108-2.9386343.0729001-5.8576208-.4981891-8.5521081-1.6731891-2.2831875-1.006099-4.1674342-2.7422092-5.3567027-4.9355676-1.1726534-2.1832436-1.7765774-4.6266568-1.756054-7.1048108-.0165487-2.7454722.6704772-5.4494155 1.9955675-7.854 1.2316713-2.3267415 3.1343937-4.2294639 5.4611352-5.4611352 2.4511366-1.2484434 5.17183-1.8745264 7.9221081-1.823027 2.3254661-.0419923 4.6282138.4635079 6.7222703 1.4756757 1.8838998.9090693 3.4497371 2.3653218 4.4928648 4.1784324 1.0338438 1.8000352 1.569821 3.8428605 1.5528649 5.9185946.0155198 2.5048242-.8143534 4.9416521-2.3554054 6.9163784-1.7237288 2.4744333-4.5604457 3.9352957-7.5758919 3.9014595-.6547383.0444203-1.3078931-.1069156-1.8763784-.4347568-.4301598-.3048461-.7299933-.7602688-.84-1.2758919-1.0759063 1.0977151-2.5494316 1.7145492-4.0864865 1.7106487-1.5597314.0422556-3.0635005-.5824568-4.1341621-1.7174595-1.1326469-1.2443469-1.7236283-2.8882307-1.6425406-4.5689189-.0158788-2.297845.6756827-4.5449246 1.9808108-6.4362162 1.2843025-2.1806363 3.6206101-3.5253389 6.1512973-3.5404865 1.591265-.098021 3.1074709.6871259 3.9457298 2.0432432l.3745946-1.6652432h3.9616216l-2.2702703 10.7576756c-.1036671.4340343-.1738733.8753842-.21 1.3201622-.0168522.2042573.0448573.4072491.1725405.5675676.1035811.1200282.2546511.1885077.4131892.1872973.6946598-.0929418 1.3440601-.3968406 1.8604865-.8706487 1.0591736-.8082099 1.9083182-1.8594205 2.4757298-3.0648648.6188618-1.2331361.9425715-2.5932609.9455675-3.972973.0485217-2.3482291-.9262963-4.6015377-2.670973-6.174-2.0721956-1.758549-4.743937-2.6480449-7.4567027-2.4825406-2.4052844-.075661-4.7866721.4967503-6.8948108 1.6572973-1.8646276 1.0826391-3.3520367 2.7114987-4.2612973 4.6665406-.9432084 1.9533386-1.4329128 4.0945345-1.4325405 6.2636757-.0212493 2.0325795.5328341 4.0297195 1.5982703 5.7608108 1.0465945 1.7143611 2.6205674 3.0433965 4.486054 3.7879459 4.1116631 1.5207103 8.6197345 1.5896031 12.775946.1952433 1.6366509-.6018602 3.0776203-1.6397036 4.167081-3.0012973zm-16.2188108-6.1660541c-.0813188.9972468.1924844 1.9911404.7730271 2.8060541.4659979.5772298 1.1709003.9089732 1.9127027.9001621.56244.0019057 1.1156599-.1428548 1.605081-.42.4305095-.2424954.8120072-.5631691 1.124919-.9455675.6262499-.7929611 1.0923568-1.7001156 1.3723783-2.670973.3645963-1.052624.5596223-2.1564941.5777838-3.2703243.0619004-.934465-.2180888-1.8595588-.7877838-2.6028649-.4901096-.5890291-1.2215045-.9231901-1.9876216-.9081081-.89325.0141062-1.7468212.3713868-2.3837838.9977838-.7984701.7801397-1.3690992 1.7632387-1.6504864 2.8435135-.342079 1.057597-.5294231 2.1591036-.5562163 3.2703243z' />
        </g>
      </svg>
    </span>
  );
};

export const ChatIcon = () => {
  return (
    <span className='chat-icon'>
      <svg height='39' viewBox='0 0 48 39' width='48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='m149.474266 23.2745456h-10.118811v-5.2922996c0-2.1990751-1.781387-3.982246-3.98219-3.982246h-26.388399c-2.199967 0-3.984866 1.7831709-3.984866 3.982246v20.7176506c0 2.1989915 1.784899 3.9821624 3.984866 3.9821624h3.414572v6.7363152c0 .8299969.671148 1.5047403 1.502009 1.5047403.426633 0 .808538-.1767676 1.080782-.4623324h.001728l7.761807-7.7805624h2.728208v.1089645c0 1.7384425 1.4084 3.1485984 3.145951 3.1485984h9.97685l6.136676 6.1490498h.000837c.21425.2231681.517622.3623416.853211.3623416.65596 0 1.187015-.5301357 1.187015-1.186932v-5.3244594h2.699754c1.736687 0 3.145812-1.4083166 3.145812-3.1468985v-16.3731187c0-1.7384704-1.409125-3.1432198-3.145812-3.1432198zm-14.264308-6.4097006c.716545 0 1.302111.5836982 1.302111 1.2994357v20.371389c0 .7193324-.585566 1.3011914-1.300383 1.3011914h-12.989759c-.389123.0071342-.739872.1660662-.993388.4213105l-.010729.005295-5.961581 5.9652873v-5.0371388c-.038403-.7478416-.653341-1.3476198-1.412804-1.354754h-4.695224c-.718413 0-1.302139-.581859-1.302139-1.3011914v-20.371389c0-.7157375.583726-1.2994357 1.302139-1.2994357zm-2.338254 16.4534626h-21.421891v2.893358h21.421891zm0-6.4310876h-21.421891v2.8916195h21.421891zm0-6.4310916h-21.421891v2.8933535h21.421891z'
          fill='#fff'
          transform='translate(-105 -14)'
        />
      </svg>
    </span>
  );
};

export const PlayIcon = () => {
  return (
    <span className='play-icon'>
      <svg height='51' viewBox='0 0 118 118' width='51' xmlns='http://www.w3.org/2000/svg'>
        <g fill='#fff' transform='translate(.065 .065)'>
          <path d='m58.596139 0c-32.369648 0-58.596139 26.226491-58.596139 58.596139 0 32.3696289 26.226491 58.596115 58.596139 58.596115 32.3696289 0 58.596115-26.2264861 58.596115-58.596115 0-32.369648-26.2264861-58.596139-58.596115-58.596139zm0 105.851075c-26.1083565 0-47.2549477-21.1465834-47.2549477-47.254936 0-26.1083565 21.1465912-47.2549477 47.2549477-47.2549477 26.1083526 0 47.254936 21.1465912 47.254936 47.2549477 0 26.1083526-21.1465834 47.254936-47.254936 47.254936z' />
          <path d='m82.5506791 54.4319501-37.0990739-21.9327209c-3.0143003-1.7811771-7.6306052-.0526976-7.6306052 4.3528173v43.8548975c0 3.9523125 4.2895803 6.3342362 7.6306052 4.3528138l37.0990739-21.9221802c3.3094025-1.9498062 3.3199425-6.7558213 0-8.7056294z' />
        </g>
      </svg>
    </span>
  );
};
